export const GENERAL_LEDGER_SOURCE_NAME = {
    PAYMENT_RECEIPT : "PAYMENT RECEIPT",
    CASH_PAYMENT : "CASH PAYMENT",
    CHEQUE_PAYMENT : "CHEQUE PAYMENT",
    CARD_PAYMENT : "CARD PAYMENT",
    BANK_PAYMENT : "BANK PAYMENT",
    RETURN_AMOUNT : "RETURN AMOUNT",
    OVER_PAYMENT : "OVER PAYMENT",
    EXPENSE_AMOUNT : "EXPENSE AMOUNT",
    PAYMENT_VOUCHER : "PAYMENT VOUCHER",
    SUPPLIER_CASH_PAYMENT : "SUPPLIER CASH PAYMENT",
    SUPPLIER_CHEQUE_PAYMENT : "SUPPLIER CHEQUE PAYMENT",
    SUPPLIER_CARD_PAYMENT : "SUPPLIER CARD PAYMENT",
    SUPPLIER_BANK_PAYMENT : "SUPPLIER BANK PAYMENT",
    PURCHASE_RETURN : "PURCHASE RETURN",
    SALES_RETURN : "SALES RETURN",
    ACCOUNT_TRANSACTION : "ACCOUNT TRANSACTION",
    CUSTOMER_CHEQUE_RETURN_CASH_PAYMENT : "CUSTOMER CHEQUE RETURN CASH PAYMENT",
    CUSTOMER_CHEQUE_RETURN_CHEQUE_PAYMENT : "CUSTOMER CHEQUE RETURN CHEQUE PAYMENT",
    CUSTOMER_CHEQUE_RETURN_BANK_PAYMENT : "CUSTOMER CHEQUE RETURN BANK PAYMENT",
    CUSTOMER_CHEQUE_RETURN_CARD_PAYMENT : "CUSTOMER CHEQUE RETURN CARD PAYMENT",
    BROUGHT_FORWARD_CASH_BOOK : "BROUGHT FORWARD CASH BOOK",
    BROUGHT_FORWARD_BANK : "BROUGHT FORWARD BANK",
    BROUGHT_FORWARD_CREDIT_CARD : "BROUGHT FORWARD CREDIT_CARD",
    ONLINE_TRANSFER_PAYMENT : "ONLINE TRANSFER PAYMENT",
    SUPPLIER_ONLINE_TRANSFER_PAYMENT : "SUPPLIER ONLINE TRANSFER PAYMENT",
    CUSTOMER_CHEQUE_RETURN_ONLINE_PAYMENT : "CUSTOMER CHEQUE RETURN ONLINE PAYMENT",
    EXPENSE_CASH_PAYMENT : "EXPENSE CASH PAYMENT",
    EXPENSE_CHEQUE_PAYMENT : "EXPENSE CHEQUE PAYMENT",
    EXPENSE_CARD_PAYMENT : "EXPENSE CARD PAYMENT",
    EXPENSE_BANK_PAYMENT : "EXPENSE BANK PAYMENT",
    EXPENSE_ONLINE_PAYMENT : "EXPENSE ONLINE PAYMENT",
    CHEQUES_MOVE_TO_BANK_PAYMENT : "CHEQUES MOVE TO BANK PAYMENT",
    BROUGHT_FORWARD_AMANA_BANK : "BROUGHT FORWARD AMANA BANK",
    BROUGHT_FORWARD_HNB_BANK : "BROUGHT FORWARD HNB BANK",
    BROUGHT_FORWARD_SAMPATH_BANK : "BROUGHT FORWARD SAMPATH BANK",
    BROUGHT_FORWARD_CREDIT_CARD_2 : "BROUGHT FORWARD CREDIT CARD_2",
    CHEQUE_PAYMENT_RETURNED : "CHEQUE PAYMENT RETURNED",
    CHEQUE_PAYMENT_REALIZED : "CHEQUE PAYMENT REALIZED",
    CHEQUE_IN_HAND: "CHEQUE IN HAND",
    SUPPLIER_CHEQUE_PAYMENT_REALIZED : "SUPPLIER CHEQUE PAYMENT REALIZED",
    SUPPLIER_CHEQUE_PAYMENT_RETURNED : "SUPPLIER CHEQUE PAYMENT RETURNED"
   }
   
   